import { createAction, createReducer } from "@reduxjs/toolkit";

export const setSecret = createAction('setSecret')
export const resetSecret = createAction('resetSecret')

const initialState = {
    value: "",
};

export const secretSlices = createReducer(initialState, {
    [setSecret]: (state, action) => {
        state.value = action.payload
    },
    [resetSecret]: (state, action) => {
        state.value = initialState
    }
}
);

//used in
// sign moat - sets the encrypted secret - this is used to decrypt the secret in the home component.
